import {
    PROPERTY_MANAGEMENT_CLOUD_ENTERPRISE_MINIMUM_PRICING,
    REAL_ESTATE_CRM_CLOUD_ENTERPRISE_MINIMUM_PRICING,
    REAL_ESTATE_CRM_CLOUD_MINIMUM_PRICING,
    REAL_ESTATE_MARKETING_CLOUD_ENTERPRISE_MINIMUM_PRICING,
    REAL_ESTATE_MARKETING_CLOUD_MINIMUM_PRICING,
    PROPERTY_MANAGEMENT_CLOUD_MINIMUM_PRICING,
    ONPERMISE_ENTERPRISE_MINIMUM_PRICING,
    MARKETING_CONTACTS_CLOUD_ENTERPRISE_MINIMUM_PRICING,
    MARKETING_CONTACTS_CLOUD_MINIMUM_PRICING,
    MARKETING_WEBSITE_CLOUD_ENTERPRISE_MINIMUM_PRICING,
    MARKETING_WEBSITE_CLOUD_MINIMUM_PRICING,
    MARKETING_APP_CLOUD_ENTERPRISE_MINIMUM_PRICING,
    MARKETING_APP_CLOUD_MINIMUM_PRICING,
    marketingPricing,
    pricing,
    PricingOptionType,
} from '../../constants'

export const calculateProductPrice = (unitNumber: number, pricingArray: [number, number][]) => {
    let finalCost = 0
    let alreadyCountedUnits = 0

    for (const [threshold, unitPricing] of pricingArray) {
        const unitsToCount = Math.max(0, Math.min(unitNumber - alreadyCountedUnits, threshold - alreadyCountedUnits))
        finalCost += unitsToCount * unitPricing
        alreadyCountedUnits = threshold
        console.log(
            `Threshold: ${threshold}, Unit Pricing: ${unitPricing}, Units To Count: ${unitsToCount}, Final Cost: ${finalCost}`
        )
    }

    return Math.round(finalCost)
}

export const calculatePrice = (unitNumber: number, pricingOption: PricingOptionType) => {
    let finalCost = 0
    const thresholdPrices = pricing[pricingOption] || [[]]
    finalCost = calculateProductPrice(unitNumber, thresholdPrices)

    // property
    if (
        pricingOption === 'propertymanagementcloud-enterprise' ||
        pricingOption === 'property-management-on-premise-enterprise'
    ) {
        finalCost += PROPERTY_MANAGEMENT_CLOUD_ENTERPRISE_MINIMUM_PRICING
    } else if (pricingOption === 'propertymanagementcloud-standard' && unitNumber > 10) {
        finalCost += PROPERTY_MANAGEMENT_CLOUD_MINIMUM_PRICING
        // crm
    } else if (pricingOption === 'real-estate-crm-cloud-enterprise') {
        finalCost += REAL_ESTATE_CRM_CLOUD_ENTERPRISE_MINIMUM_PRICING
    } else if (pricingOption === 'real-estate-crm-cloud-standard' && unitNumber > 5) {
        finalCost += REAL_ESTATE_CRM_CLOUD_MINIMUM_PRICING
        // matketing
    } else if (pricingOption === 'real-estate-marketing-cloud-enterprise') {
        finalCost += REAL_ESTATE_MARKETING_CLOUD_ENTERPRISE_MINIMUM_PRICING
    } else if (pricingOption === 'real-estate-marketing-cloud-standard' && unitNumber > 5) {
        finalCost += REAL_ESTATE_MARKETING_CLOUD_MINIMUM_PRICING
    }
    // contacts
    else if (pricingOption === 'marketing-contacts-cloud-enterprise') {
        finalCost += MARKETING_CONTACTS_CLOUD_ENTERPRISE_MINIMUM_PRICING
    } else if (pricingOption === 'marketing-contacts-cloud-standard' && unitNumber > 5) {
        finalCost += MARKETING_CONTACTS_CLOUD_MINIMUM_PRICING
    }
    // website
    else if (pricingOption === 'marketing-website-cloud-enterprise') {
        finalCost += MARKETING_WEBSITE_CLOUD_ENTERPRISE_MINIMUM_PRICING
    } else if (pricingOption === 'marketing-website-cloud-standard' && unitNumber > 5) {
        finalCost += MARKETING_WEBSITE_CLOUD_MINIMUM_PRICING
    }
    // app
    else if (pricingOption === 'marketing-app-cloud-enterprise') {
        finalCost += MARKETING_APP_CLOUD_ENTERPRISE_MINIMUM_PRICING
    } else if (pricingOption === 'marketing-app-cloud-standard' && unitNumber > 5) {
        finalCost += MARKETING_APP_CLOUD_MINIMUM_PRICING
    }

    console.log(`Unit Number: ${unitNumber}, Pricing Option: ${pricingOption}, Final Cost: ${finalCost}`)
    return Math.round(finalCost)
}
